import { Toast } from "react-hot-toast";

export type ToastArgs =
  | Partial<
      Pick<
        Toast,
        | "id"
        | "style"
        | "className"
        | "position"
        | "icon"
        | "duration"
        | "ariaProps"
        | "iconTheme"
      >
    >
  | undefined;

// gloabl toast styles
export const toastSuccess = {
  position: "bottom-right",
  duration: 1500,
  style: {
    borderRadius: "var(--border-radius)",
    boxShadow: "0px 8px 8px 0px #191E26",
    border: "none",
    padding: "16px",
    color: "var(--text-color-primary)",
    background: "var(--toast-background-color-primary)",
    fontSize: "12px",
  },
} as ToastArgs;

export const toastFail = {
  position: "bottom-right",
  duration: 3000,
  style: {
    borderRadius: "var(--border-radius)",
    boxShadow: "0px 8px 8px 0px #191E26",
    border: "none",
    padding: "16px",
    color: "var(--text-color-primary)",
    background: "var(--toast-background-color-fail)",
    fontSize: "12px",
  },
} as ToastArgs;

export const toastPersist = {
  position: "bottom-right",
  duration: 150000,
  style: {
    borderRadius: "var(--border-radius)",
    boxShadow: "0px 8px 8px 0px #191E26",
    padding: "16px",
    color: "var(--text-color-primary)",
    background: "var(--toast-background-color-persist)",
    fontSize: "12px",
  },
} as ToastArgs;

export const toastInfo = {
  position: "bottom-right",
  duration: 1500,
  style: {
    border: "1px solid white",
    padding: "16px",
    color: "white",
    background: "#5C10E4",
  },
} as ToastArgs;

export const IMG_LOGO: string = "/winslow_logo.svg";
export const IMG_FOUR_O_FOUR: string = "/404.png";
export const IMG_MOON: string = "/errorpage/moon.svg";
export const IMG_ARROW: string = "/errorpage/arrow.svg";

export const DD_STATE = {
  SCHEDULED: "SCHEDULED",
  FINISHED: "FINISHED",
  LIVE: "LIVE",
};

export const CONNECTOR_APPS = {
  JIRA: "JIRA",
  GITHUB: "GITHUB",
  NONE: "NONE",
};

export const GH_CLIENT_ID: string = "3bc49ffb1e2b80e3c579";

// Dev/local:
export const JIRA_CLIENT_ID: string = "puTIobT7aTTtNL8kEWeM4ahom05FFD1J";

// Prod
// export const JIRA_CLIENT_ID: string = "goW1ixpFs0wmAKpGff81VFxMDcfvp0HK";

export const ADD_A_LOOM_BUTTON_COLOR: string = "#5C10E4";

export const WEBSITE: string = "https://usewinslow.com";

export const HUBSPOT_SIGNUP_LINK =
  "https://meetings.hubspot.com/niel-robertson/winslow-team?uuid=e196a867-1e1e-411a-9874-d1ea6c69e65e";
